import React from 'react';
import Dashboard from './Dashboard';

const StudentDashboard = () => {
  const userData = localStorage.getItem('user');
  const user = userData ? JSON.parse(userData) : null;
  const enabledClasses = user && user.classes ? Object.keys(user.classes).filter(c => user.classes[c]) : [];

  return (
    <Dashboard
      hideManageUsers={true}
      viewerOnly={true}
      allowedClasses={enabledClasses.length ? enabledClasses : ['I']}
      title="Student Dashboard"
    />
  );
};

export default StudentDashboard;
